import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import errorSign from '../../assets/images/errorSign.svg';
import PropTypes from 'prop-types';
import './style.scss'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 340,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 1,
    paddingLeft: 4,
    paddingRight: 4,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
}

const DeleteModal = ({ openDeleteModal = false, setOpenDeleteModal, handleDelete, activeScreen }) => {
    const confirmDelete = () => {
        
        handleDelete();
        setOpenDeleteModal(false);
    };
    console.log(activeScreen,"werwrwr")
    useEffect(() => {
    if (openDeleteModal) {
      const timeoutId = setTimeout(() => {
        const cancelButton = document.getElementById("cancel-button-id");
        if (cancelButton) {
          cancelButton.focus();
        }
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [openDeleteModal]);
    if (!openDeleteModal) return null;

    return (
        <div className="delte_modal_wrapper">
            <Modal
                open={openDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="delte_modal"
                role="presentation"
            >
                <Box sx={style}>
                    <div className="Modal_header">
                        <h1>
                            <img src={errorSign} alt="error icon" className="deleteDeviceiconimg" style={{marginRight: "5px"}} /> 
                            <span data-testid="modal-title">Delete Confirmation</span>
                        </h1>
                    </div>
                    <div className="Modal_middle">
                        <div className="inputdrapper">
                             <p data-testid="modal-description">{`Are you sure you want to delete this ${activeScreen == "devices" ? "device" : "device Type"}?`}</p>
                        </div>
                    </div>
                    <div className="Modal_footer">
                        <Box sx={{ display: 'flex' }}>
                            <Button 
                                variant="outlined" 
                                className="cancelBtn" 
                                onClick={() => setOpenDeleteModal(false)}
                                data-testid="cancel-button"
                                 id="cancel-button-id"
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                className="saveBtn" 
                                onClick={confirmDelete}
                                data-testid="delete-button"
                            >
                                Delete
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

DeleteModal.propTypes = {
    openDeleteModal: PropTypes.bool,
    setOpenDeleteModal: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
};
export default DeleteModal;
